import * as React from 'react';
import { Secondary } from 'rcd-cpp-ui/ui/button';
import { Schema } from '../../../types/Metadata';
import { clone, getSchema, isSystemSchema, parseField } from '../../../utils';
import { findOne } from 'rcd-cpp-workspace/utils/array';
import { FieldType } from '../../../enums/FieldType';
import { useSelector } from '../../../utils/useSelector';

export const D3Schema = () => {
  const schemas = useSelector(s => clone(s.planning.selectedWorkspace.schemas));
  const refId = useSelector(s => s.planning?.selectedWorkspace?.props?.refId);
  const show = useSelector(s =>
    [11714, 11757, 54098, 63080].includes(s.app?.user?.employeeId)
  );
  if (!show) return null;
  const showSchemas = () => {
    const data = getData(schemas);
    localStorage.setItem('cpp-schema-d3', JSON.stringify(data));
    openD3Link(refId);
  };
  return <Secondary onClick={showSchemas}>Generate D3 Schema</Secondary>;
};

const getData = (schemas: Schema[]) => {
  const complementaryRelationType = {
    // EQUIVALENT: 'EQUIVALENT',
    // PARENT_OF: 'CHILD_OF',
    // IMPLIED_BY: 'IMPLIES'
  };
  schemas.forEach(schema => {
    const dataType = schema.props?.type;
    schema?.props?.fields.forEach(f => {
      const relationType = complementaryRelationType[f.relationType];
      if (!relationType) return;
      const targetSchema = getSchema(schemas, f.dataType);
      if (
        targetSchema &&
        !findOne(targetSchema.props?.fields, {
          dataType,
          relationType
        })
      ) {
        targetSchema.props.fields.push({
          ...f,
          dataType,
          relationType
        });
      }
    });
  });
  const nodes = schemas.map(s => ({
    id: s.props.refId,
    label: s.props.name,
    type: s.props.type,
    group: s.props.type == 'Item' ? 1 : isSystemSchema(s) ? 2 : 3
  }));
  const links = [];
  schemas.forEach(s => {
    s.props.fields
      .filter(f => f.fieldType == FieldType.reference)
      .forEach(f => {
        const fs = parseField(f.key, schemas);
        if (fs.referenceSchema) {
          const link = {
            source: s.props.refId,
            target: fs.referenceSchema.props.refId,
            type: f.relationType
          };
          const l = findOne(links, {
            source: link.source,
            target: link.target
          });
          if (l) {
            if (l.type.indexOf(link.type) < 0) {
              l.type = l.type + ',' + link.type;
            }
          } else links.push(link);
        }
      });
  });
  return { nodes, links };
};

const openD3Link = async (refId: string) => {
  let link = document.createElement('a');
  link.setAttribute('href', process.env.CPP_PLAN_URI + '/cppplan/d3.html');
  link.setAttribute('target', '_blank');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
